<template>
  <div class="GiftSettingPage" v-show="load">
    <ClientCheck v-if="currentSkin?.data?.gift" title="送礼是否显示" :value=config.showGift
                 :onChange="(value)=>onChange('showGift',value)"></ClientCheck>
    <ClientInput v-if="currentSkin?.data?.gift" title="最小显示金额" :value="config.minGiftPrice" unit="¥"
                 :onChange="(value)=>onChange('minGiftPrice',value)"></ClientInput>
    <ClientCheck v-if="currentSkin?.data?.captain" title="是否显示舰长上舰" :value=config.showCaptain
                 :onChange="(value)=>onChange('showCaptain',value)"></ClientCheck>
    <ClientCheck v-if="currentSkin?.data?.admiral" title="是否显示提督上舰" :value=config.showAdmiral
                 :onChange="(value)=>onChange('showAdmiral',value)"></ClientCheck>
    <ClientCheck v-if="currentSkin?.data?.governor" title="是否显示总督上舰" :value=config.showGovernor
                 :onChange="(value)=>onChange('showGovernor',value)"></ClientCheck>
    <div class="barrageSearch">
      <el-form
          :inline="true"
          label-position="left"
          label-width="135px"
          :model="queryParams"
          ref="queryForm"
          style="max-width: 1000px"
          @submit.native.prevent
      >
        <el-form-item v-if="false">
          <span slot="label">
             <span class="roomId">直播间号</span>
          </span>
          <el-input
              v-model="roomObj.roomId"
              placeholder="请输入直播间号"
              size="small"
              class="searchInput"
              clearable
              @input="saveRoomId"
          />
        </el-form-item>
        <el-form-item>
          <span slot="label">
             <span class="roomId">皮肤名称</span>
          </span>
          <el-input
              v-model="queryParams.productName"
              placeholder="请输入皮肤名称"
              size="small"
              class="searchInput"
              clearable
              @keyup.enter.native="handleQuery"
          />
        </el-form-item>
        <el-form-item>
          <el-button
              type="primary"
              icon="el-icon-search"
              class="searchBtn"
              @click="handleQuery">搜索</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="headTitle">当前皮肤：{{ currentSkin.name }}</div>
    <div class="skinBox">
      <div
          v-for="item in skins"
          :key="item.value"
          :class='`item ${item.value===config.skin? "active":""}`'
          @click="changeSkin(item)"
      >
        <div class="img">
          <img :src='item.img' :alt="item.name">
        </div>
        <div class="name">{{ item.name }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import ClientCheck from "@/views/client/component/Check"
import ClientInput from "@/views/client/component/Input"
import { getLiveChatProductsApi } from "@/api/livechat/livechat"

export default {
  name: "GiftSetting",
  inject: ['giftConfig', 'roomObj'],
  components: { ClientCheck, ClientInput },
  data() {
    return {
      skins: [],
      config: this.giftConfig,
      load: false,
      roomObj: this.roomObj,
      // 查询参数
      queryParams: {
        categoryId: 29,
        platformId: 2,
        searchValue: null,
        productName: null,
      }
    }
  },
  computed: {
    currentSkin: vm => {
      if (!vm.config.skin || !vm.skins.length) {
        return {}
      }
      const item = vm.skins.find(e => e.value === vm.config.skin)
      if (item) {
        return item
      }
      return {}
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    /** 搜索按钮操作 */
    handleQuery() {
      this.getList();
    },
    getList() {
      this.queryParams.searchValue = this.roomObj.roomId
      getLiveChatProductsApi(this.queryParams).then(res => {
        if (res.data) {
          this.config.skin = res.data.defaultValue
          this.skins = res.data.list.filter(item => item.hidden !== true)
        } else {
          this.config.skin = ''
          this.skins = []
        }

        /*if (!this.currentSkin.name) {
          this.$message.error("皮肤缺失，请联系管理员")
        }*/
        this.load = true
        this.associationSkin()
      })
    },
    onChange(key, value) {
      this.config[key] = value
      this.changeTips()
    },
    changeSkin(item) {
      this.config.skin = item.value
      this.associationSkin()
      this.changeTips()
    },
    changeTips() {
      this.$message({
        message: '<span style="font-size: 25px; padding-right: 15px;">检测到配置修改，请复制房间URL粘贴到OBS/直播姬中以应用改动</span>',
        type: 'success',
        duration: 5000,
        dangerouslyUseHTMLString: true,
        showClose: true,
        offset: 300
      })
    },
    associationSkin() {
      this.config.showGift = Boolean(this.currentSkin?.data?.gift)
      this.config.showCaptain = Boolean(this.currentSkin?.data?.captain)
      this.config.showAdmiral = Boolean(this.currentSkin?.data?.admiral)
      this.config.showGovernor = Boolean(this.currentSkin?.data?.governor)
    }
  }
}
</script>

<style scoped lang="less">
.el-form-item {
  margin-bottom: 12px;
}
.GiftSettingPage {
  padding: 20px 40px;

  .ClientCheck, .ClientInput {
    margin-bottom: 10px;
  }

  .barrageSetting {
    display: flex;
    align-items: center;

    .title {
      width: 209px;
      height: 36px;
      background: #b9c8df;
      color: #fff;
      font-size: 20px;
      font-weight: bold;
      border-radius: 36px;
      text-align: center;
      line-height: 36px;
    }

    input {
      display: block;
      margin-left: 8px;
      width: 75px;
      height: 28px;
      line-height: 28px;
      border: solid 2px #a2b4cf;
      outline: none;
      font-size: 17px;
      color: #a2b4cf;
      text-align: center;
      padding: 0;
    }
  }

  .barrageSearch {
    margin-top: 12px;
    display: flex;
    align-items: center;

    .roomId {
      width: 109px;
      height: 36px;
      background: #b9c8df;
      color: #fff;
      font-size: 20px;
      font-weight: bold;
      border-radius: 36px;
      text-align: left;
      line-height: 36px;
      padding: 8px 20px;
    }
    .searchInput {
      display: block;
      margin: 0 8px;
      width: 240px;
      height: 32px;
      line-height: 32px;
      border: solid 2px #a2b4cf;
      outline: none;
      font-size: 17px;
      color: #a2b4cf;
      padding: 0;
      & /deep/ .el-input__inner {
        border: none;
        height: 32px;
        line-height: 32px;
        color: #a2b4cf;
      }
    }

    .searchBtn {
      color: var(--btnFontColor2);
      background: var(--btnBgColor2);
      padding: 8px 20px;
      font-size: 17px;
      font-weight: bold;
      border-radius: 25px;
      cursor: pointer;
      border: solid 2px #869bb7;
    }
  }

  .headTitle {
    color: #b9c8df;
    font-size: 20px;
    font-weight: bold;
    margin-bottom: 8px;
    margin-top: 20px;
  }

  .skinBox {
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    flex-wrap: wrap;
    gap: 10px;

    .item {
      width: 200px;
      height: 130px;
      //border-radius: 5px;
      border: 4px solid transparent;
      overflow: hidden;
      position: relative;
      cursor: pointer;

      &.active {
        border-color: #8ba6cf;
      }

      .img {
        width: 100%;
        height: 100%;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }

      .name {
        position: absolute;
        max-width: 100%;
        bottom: 2px;
        right: 2px;
        padding: 5px 10px;
        background: #fff;
        color: #8ba6cf;
        border: 2px solid #8ba6cf;
        border-radius: 5px;

      }
    }

  }
}
</style>
